/**
 * Algolia InstantSearch Configuration
 * Uses patient-specific indices for better isolation and performance
 */

export const algoliaConfig = {
  appId: "L37Z1SYO65",
  searchKey: "e935ddebf3dd3e77bdbe9fd920a6de4a",
  adminKey: "4dc17ca6b14d3102ac44f23390f8a51e", // For server-side indexing
  indices: {
    patients: "patients",
    documents: "documents",
    procedures: "procedures",
  },
  // Configuration for InstantSearch widgets
  searchableAttributes: {
    patients: ["name", "mrn", "email", "specialty", "conditions", "chiefComplaint"],
    documents: ["title", "content", "patientName", "type", "summary"],
    procedures: ["name", "cptCode", "description", "patientName", "specialty"],
  },
  // Facets for filtering
  attributesForFaceting: {
    patients: ["specialty", "status", "gender", "ageGroup"],
    documents: ["type", "patientId", "createdAt"],
    procedures: ["specialty", "patientId", "procedureDate"],
  },
  // Typo tolerance settings
  typoTolerance: {
    minWordSizefor1Typo: 4,
    minWordSizefor2Typos: 8,
  },
  // Snippeting for long content
  snippetAttributes: {
    documents: ["content:200", "summary:100"],
    patients: ["chiefComplaint:50"],
  },
};

/**
 * Get the patient-specific timeline index name
 * Each patient has their own index for faster queries and better isolation
 * @param patientId - The patient's unique ID
 * @returns The index name for this patient's timeline
 */
export function getPatientTimelineIndex(patientId: string): string {
  // Sanitize the patientId to ensure valid index name
  // Algolia index names can contain alphanumeric chars, underscores, and hyphens
  const sanitizedId = patientId.replace(/[^a-zA-Z0-9_-]/g, "_");
  return `patient_timeline_${sanitizedId}`;
}

/**
 * Extract patient ID from a timeline index name
 * @param indexName - The index name
 * @returns The patient ID or null if not a patient timeline index
 */
export function getPatientIdFromIndex(indexName: string): string | null {
  const prefix = "patient_timeline_";
  if (indexName.startsWith(prefix)) {
    return indexName.slice(prefix.length);
  }
  return null;
}

export default algoliaConfig;
